// iOS Safari (в т.ч. «Экран → Крупный текст») раздувает шрифты через -webkit-text-size-adjust.
// На native это режет maxFontSizeMultiplier; react-native-web игнорирует оба пропа — блокируем в CSS/JS.
const LOCK_STYLE_ID = 'web-font-scaling-lock'

const LOCK_CSS = `
  html {
    -webkit-text-size-adjust: none !important;
    text-size-adjust: none !important;
    font-size: 16px;
    touch-action: manipulation;
  }
  body,
  #root,
  #root *,
  input,
  textarea,
  select,
  button {
    -webkit-text-size-adjust: none !important;
    text-size-adjust: none !important;
  }
`

function isMobileTouchDevice(): boolean {
  return window.matchMedia('(hover: none) and (pointer: coarse)').matches
}

function installPinchZoomBlock() {
  if (!isMobileTouchDevice()) return

  document.addEventListener(
    'touchmove',
    (event) => {
      if (event.touches.length > 1) {
        event.preventDefault()
      }
    },
    { passive: false },
  )

  document.addEventListener('gesturestart', (event) => event.preventDefault())
  document.addEventListener('gesturechange', (event) => event.preventDefault())
}

export function installWebFontScalingLock() {
  if (typeof document === 'undefined') return

  document.documentElement.style.setProperty('-webkit-text-size-adjust', 'none')
  document.documentElement.style.setProperty('text-size-adjust', 'none')

  if (!document.getElementById(LOCK_STYLE_ID)) {
    const style = document.createElement('style')
    style.id = LOCK_STYLE_ID
    style.textContent = LOCK_CSS
    document.head.appendChild(style)
  }

  installPinchZoomBlock()
}
